/**
 * Note: this tries to match the PHP class closely.
 * If there is a bug here, there could also be a bug there...
 * ... and changes should be reflected on both sides.
 */

export function move(items, id, position) {
    const itemCount = items.length;

    if (itemCount === 1) {
        items[0].position = 1;
        return items;
    }

    // If moving to a position larger than item count... mark this last.
    if (position > itemCount) {
        position = itemCount;
    }

    // If moving before the starting point... mark this first
    if (position < 1) {
        position = 1;
    }

    const otherItems = items.filter(item => item.id !== id);

    otherItems.sort((a, b) => {

        // Most of the times, the shorthand should be fine.
        // But it's here if we need it:
        //
        // if ( a.position < b.position ) {
        //     return -1;
        // }
        // if ( a.position > b.position ) {
        //     return 1;
        // }
        // return 0;

        return a.position - b.position;
    });

    otherItems.forEach((item, index) => {
        let newPosition = index + 1;

        if (newPosition >= position) {
            newPosition = newPosition + 1;
        }

        item.position = newPosition;
    });

    const itemMoving = items.filter(item => item.id === id)[0];
    itemMoving.position = position;

    return items;
}
